module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/suffix.js
// module id = 2069
// module chunks = 0